import * as React from 'react';
import { stringToColor } from '../../utils';

interface AvatarProps {
  text: string;
  displayText: string;
}

export const Avatar = ({ text, displayText }) => {
  return (
    <>
      <div
        className="avatar-child"
        style={{
          backgroundColor: stringToColor(text),
          borderRadius: '75px',
          height: '28px',
          width: '28px',
          fontWeight: '500',
          fontSize: '15px',
          lineHeight: '22px',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {' '}
        {<div className="avatar-children">{displayText}</div>}
      </div>
    </>
  );
};
